import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
  OnDestroy
} from '@angular/core';
import { VexPopoverService } from '@vex/components/vex-popover/vex-popover.service';
import { ToolbarUserDropdownComponent } from './toolbar-user-dropdown/toolbar-user-dropdown.component';
import { MatIconModule } from '@angular/material/icon';
import { MatRippleModule } from '@angular/material/core';
import { AuthService } from '../../../../core/auth/auth.service';
import { AsyncPipe, NgIf } from '@angular/common';
import { Subject, takeUntil } from 'rxjs';

@Component({
  selector: 'vex-toolbar-user',
  templateUrl: './toolbar-user.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [MatRippleModule, MatIconModule, AsyncPipe, NgIf]
})
export class ToolbarUserComponent implements OnInit, OnDestroy {
  dropdownOpen: boolean = false;
  currentUser$ = this.authService.currentUser$;
  private destroy$ = new Subject<void>();

  constructor(
    private popover: VexPopoverService,
    private cd: ChangeDetectorRef,
    private authService: AuthService
  ) {}

  ngOnInit() {
    this.authService.currentUser$
      .pipe(takeUntil(this.destroy$))
      .subscribe(user => {
        this.cd.markForCheck();
      });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  getUserDisplayName(user: any): string {
    if (user.nombre && user.apellido) {
      return `${user.nombre} ${user.apellido}`.trim();
    } else if (user.nombre) {
      return user.nombre;
    } else if (user.email) {
      return user.email.split('@')[0];
    }
    return 'Usuario';
  }

  getInitials(user: any): string {
    const n = user.nombre?.trim() ?? '';
    const a = user.apellido?.trim() ?? '';
    const initials = `${n.charAt(0)}${a.charAt(0)}`.toUpperCase();
    return initials || (user.email?.charAt(0).toUpperCase() ?? '?');
  }

  getAvatarColor(user: any): string {
    const seed = `${user.nombre ?? ''}${user.apellido ?? ''}`;
    let hash = 0;
    for (let i = 0; i < seed.length; i++) {
      hash = seed.charCodeAt(i) + ((hash << 5) - hash);
    }
    return `hsl(${Math.abs(hash) % 360}, 55%, 78%)`;
  }

  showPopover(originRef: HTMLElement) {
    this.dropdownOpen = true;
    this.cd.markForCheck();

    const popoverRef = this.popover.open({
      content: ToolbarUserDropdownComponent,
      origin: originRef,
      offsetY: 12,
      position: [
        {
          originX: 'center',
          originY: 'top',
          overlayX: 'center',
          overlayY: 'bottom'
        },
        {
          originX: 'end',
          originY: 'bottom',
          overlayX: 'end',
          overlayY: 'top'
        }
      ]
    });

    popoverRef.afterClosed$.subscribe(() => {
      this.dropdownOpen = false;
      this.cd.markForCheck();
    });
  }
}